<template>
    <div class="product_list service--georgia">
        <div class="service">
            <div class="solutions__banner" v-if="service.page_image">
                <img :src="service.page_image" alt="" class="solutions__img">
            </div>

            <div class="solution__item" v-for="(solution, index) in service.article" :key="index">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="solution__img service__img" :style="{ 'background-image': 'url(' + solution.url + ')' }"></div>
                    </div>
                    <div class="col-12 col-md-8 service__detail">
                        <h2 class="service__title"> {{ solution.title }} </h2>
                        <div class="service__description" v-html="limitLength(solution.content)"></div>
                        <div class="service__btn-container">
                            <a href="#" @click.prevent="goTo(solution.slug)" class="btn btn-primary solution__btn service__btn">Cere Oferta</a> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 
    export default {
        data () {
            return {
                service: {
                    article: {
                        
                    }
                }
            }
        },
        created () {
            this.getService()
        },
        methods: {
            getService () {
                this.$http.get(`/pages/${this.$route.path.replace('/', '')}`)
                .then(response => {
                    this.service = response.data
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            },
            limitLength (text) {
                if(text.length > 450) {
                    return text.substring(0,450) + '...'
                } else {
                    return text
                }
            },
            goTo (slug) {
                this.$router.push({path: `/article/${slug}`})
            },
            goToArticle (slug) {
                this.$router.push(`/article/${slug}`)
            }
        }
    }
</script>